module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/mtorn0-721c2ec50844d100140f3363397c2371.jpg";